import { Alert as ChakraAlert } from '@chakra-ui/react';

type AlertProps = React.ComponentProps<typeof ChakraAlert> & {
  name?: string;
  severity?:
    | 'info'
    | 'warning'
    | 'success'
    | 'error'
    | 'manualreview'
    | 'fadeAlert'
    | 'extractionFailed';
};

const Alert = ({ children, ...props }: Readonly<AlertProps>) => {
  return <ChakraAlert {...props}>{children}</ChakraAlert>;
};

export default Alert;
